<script>
import GlobalHeader from "@/components/common/GlobalHeader.vue";
import { store } from "@/store";
import api from "@/api";
import { ERROR_TYPE } from "@/lib/type";

export default {
    name: "ReservationTeacherDetail",
    components: { GlobalHeader },
    data: () => ({
        store,
        reservation: {}
    }),
    methods: {
        async getReservation(token, id) {

            let params = {
                token: token
            };

            try {
                this.reservation = await api.getTeacherAppReservation(params, id);

                if(this.reservation.code) {
                    throw new Error(this.reservation.code);
                }

                store.auth = {
                    type: "APP_USER",
                    token: token,
                }
            } catch (e) {
                this.handleErrorMessage(e);
            }
        },
        getStatusMessage(reservedStatus) {
            switch(reservedStatus) {
                case "WAITING": return "대기";
                case "ACCEPTED": return "승인";
                case "DENIED": return "반려";
                case "CANCELED": return "취소";
                default: return "";
            }
        },
        async handleAllow() {

            let params = {
                token: this.$route.query.token
            };
            try {
                let response = await api.teacherAppReservationAllow(params, this.$route.params.id);

                if (response.result === "success") {
                    this.$alert.success({ message: "예약이 승인되었습니다." });
                    this.reservation.status = "ACCEPTED";
                } else {
                    throw new Error(response.code);
                }
            } catch (e) {
                this.handleErrorMessage(e);
            }
        },
        async handleDeny() {

            let params = {
                token: this.$route.query.token
            };
            try {
                let response = await api.teacherAppReservationDeny(params, this.$route.params.id);

                if (response.result === "success") {
                    this.$alert.success({ message: "예약이 거절되었습니다." });
                    this.reservation.status = "DENIED";
                } else {
                    throw new Error(response.code);
                }

            } catch (e) {
                this.handleErrorMessage(e);
            }
        },
        handleErrorMessage(error) {
            let result = null;

            if (typeof error === "object") {
                result = ERROR_TYPE[error.message];
            } else {
                result = ERROR_TYPE[error];
            }

            const message = !result ? "알 수 없는 오류 발생" : result;

            this.$alert.danger({ message });
        },
    },
    mounted() {
        this.getReservation(this.$route.query.token, this.$route.params.id);
    },
};
</script>

<template>
    <div class="container">
        <div class="layout-content">
            <global-header
                :status="'NONE'"
                :title="'예약 신청내역'"
            />
            <div class="content" v-if="!reservation.code && reservation.reservationId">
                <div class="content-table ">
                    <div class="content-table__row detail-item">
                        <div class="content-table__col detail-item__title">
                            예약자명
                        </div>
                        <div class="content-table__col detail-item__content">
                            {{ reservation.visitorName }}
                        </div>
                    </div>
                    <div class="content-table__row detail-item">
                        <div class="content-table__col detail-item__title">
                            전화번호
                        </div>
                        <div class="content-table__col detail-item__content">
                            {{ reservation.visitorPhone }}
                        </div>
                    </div>
                    <div class="content-table__row detail-item">
                        <div class="content-table__col detail-item__title">
                            예약구분
                        </div>
                        <div class="content-table__col detail-item__content">
                            {{ reservation.visitorCategory === "PARENT" ? "학부모" : "외부인" }}
                        </div>
                    </div>
                    <div class="content-table__row detail-item">
                        <div class="content-table__col detail-item__title">
                            예약일시
                        </div>
                        <div class="content-table__col detail-item__content">
                            {{ `${reservation.reservedDate} ${reservation.reservedTime}` }}
                        </div>
                    </div>
                    <div class="content-table__row detail-item">
                        <div class="content-table__col detail-item__title">
                            예약상태
                        </div>
                        <div class="content-table__col detail-item__content">
                            {{ getStatusMessage(reservation.status) }}
                        </div>
                    </div>
                    <div class="content-table__row detail-item">
                        <div class="content-table__col detail-item__title">
                            방문 선생님
                        </div>
                        <div class="content-table__col detail-item__content">
                            {{ reservation.reservedTeacherName }}
                        </div>
                    </div>
                    <div class="content-table__row detail-item" v-if="reservation.visitorCategory === 'PARENT'">
                        <div class="content-table__col detail-item__title">
                            자녀정보
                        </div>
                        <div
                            class="content-table__col detail-item__content">
                            {{ reservation.childInfo }}
                        </div>
                    </div>
                    <div class="content-table__row detail-item-purpose">
                        <div class="content-table__col detail-item-purpose__title">
                            방문목적
                        </div>
                        <div class="content-table__col detail-item-purpose__content">
                            {{ reservation.visitPurpose }}
                        </div>
                    </div>
                </div>
                <div class="submit-btn">
                    <button @click="handleAllow()" v-if="reservation.status === 'WAITING'">승인하기</button>
                    <button class="white" @click="handleDeny()" v-if="reservation.status === 'WAITING'">반려하기</button>
                    <button disabled v-if="reservation.status !== 'WAITING'">이미 처리 완료 되었습니다.</button>
                </div>

            </div>
        </div>
    </div>
</template>


<style scoped lang="scss">

</style>